"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports.disabledFields = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _disabledFields;
var displayFieldPrefix = 'general.display';
var profileFieldPrefix = 'account.profile';
var recoveryFieldPrefix = 'account.recovery';
var dataSharingFieldPrefix = 'account.dataSharing';
var fields = exports.fields = {
  general: {
    display: {
      theme: "".concat(displayFieldPrefix, ".theme"),
      language: "".concat(displayFieldPrefix, ".language"),
      undoDuration: "".concat(displayFieldPrefix, ".undoDuration"),
      smartReply: "".concat(displayFieldPrefix, ".enableSmartReply"),
      followUpNudge: "".concat(displayFieldPrefix, ".enableFollowUpNudge"),
      replyToNudge: "".concat(displayFieldPrefix, ".enableReplyToNudge"),
      messagePreviewText: "".concat(displayFieldPrefix, ".enableMessagePreviewText"),
      attachmentPreview: "".concat(displayFieldPrefix, ".enableAttachmentPreview"),
      priceAlertTracking: "".concat(displayFieldPrefix, ".enablePriceAlert"),
      smartFolders: "".concat(displayFieldPrefix, ".enableSift"),
      displayExternalImages: "".concat(displayFieldPrefix, ".enableDisplayExternalImages"),
      backgroundImageMode: "".concat(displayFieldPrefix, ".backgroundImageMode"),
      backgroundImageFilename: "".concat(displayFieldPrefix, ".backgroundImageFilename"),
      enableEmptyInboxDailyQuote: "".concat(displayFieldPrefix, ".enableEmptyInboxDailyQuote")
    },
    autoAcceptNewContacts: 'general.autoAcceptNewContacts',
    quickAction: 'general.quickAction'
  },
  notifications: {
    webNotification: "notifications.enableWebNotification",
    notificationFilter: "notifications.notificationFilter"
  },
  signature: {
    signature: "signature.enableSignature",
    content: "signature.content",
    enabled: "signatureExt.enableSignature",
    customize: "signatureExt.customizePerAccount",
    signatures: "signatureExt.signatures"
  },
  vacationResponder: {
    vacationResponder: "vacationResponder.enableVacationResponder",
    start: 'vacationResponder.start',
    end: 'vacationResponder.end',
    subject: 'vacationResponder.subject',
    content: 'vacationResponder.content'
  },
  account: {
    profile: {
      avatar: "".concat(profileFieldPrefix, ".avatar"),
      senderName: "".concat(profileFieldPrefix, ".senderName")
    },
    recovery: {
      email: "".concat(recoveryFieldPrefix, ".email"),
      verified: "".concat(recoveryFieldPrefix, ".verified")
    },
    dataSharing: {
      insightEnabled: "".concat(dataSharingFieldPrefix, ".insightEnabled")
    }
  }
};
var disabledFields = exports.disabledFields = (_disabledFields = {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_disabledFields, fields.general.display.theme, true), fields.general.display.language, true), fields.general.display.undoDuration, false), fields.general.display.smartReply, true), fields.general.display.followUpNudge, true), fields.general.display.replyToNudge, true), fields.general.display.messagePreviewText, true), fields.general.display.attachmentPreview, true), fields.general.display.priceAlertTracking, true), fields.general.display.smartFolders, true), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_disabledFields, fields.notifications.webNotification, true), fields.notifications.notificationFilter, true), fields.signature.signature, false), fields.signature.content, false), fields.vacationResponder.vacationResponder, false), fields.vacationResponder.start, false), fields.vacationResponder.end, false), fields.vacationResponder.subject, false), fields.vacationResponder.content, false), fields.account.profile.avatar, false), (0, _defineProperty2["default"])((0, _defineProperty2["default"])(_disabledFields, fields.account.profile.senderName, false), fields.account.dataSharing.insightEnabled, false));
//# sourceMappingURL=fields.js.map